/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_setting_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setting Password...`)
};

const zh_hans1_settings_setting_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置密码中...`)
};

const zh_hant1_settings_setting_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定密碼中…`)
};

const fr_settings_setting_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Définition du mot de passe…`)
};

const de_settings_setting_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort wird gesetzt…`)
};

const ja_settings_setting_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードを設定中…`)
};

const ko_settings_setting_password = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비밀번호 설정 중...`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_setting_password = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_setting_password(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_setting_password", locale)
	if (locale === "en") return en_settings_setting_password(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_setting_password(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_setting_password(inputs)
	if (locale === "fr") return fr_settings_setting_password(inputs)
	if (locale === "de") return de_settings_setting_password(inputs)
	if (locale === "ja") return ja_settings_setting_password(inputs)
	return ko_settings_setting_password(inputs)
};